module.exports = __webpack_public_path__ + "img/002.c05e7377.png";